import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT = { active: false, sale_percent: 0, free_ship_min_items: 3, ends_at: null };
const PromoContext = createContext(DEFAULT);

export function PromoProvider({ children }) {
  const [promo, setPromo] = useState(DEFAULT);
  useEffect(() => {
    let alive = true;
    const fetchPromo = () => api.get("/promo").then((r) => { if (alive) setPromo(r.data); }).catch(() => {});
    fetchPromo();
    const id = setInterval(fetchPromo, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);
  return <PromoContext.Provider value={promo}>{children}</PromoContext.Provider>;
}

export const usePromo = () => useContext(PromoContext);
